import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { deleteCustomNotificationById } from 'api/auth.api';

export const useCustomNotificationDelete = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCustomNotificationById,

    onSuccess: (res) => {
      //   toast({
      //     title: 'Notification deleted',
      //     description: res?.data?.message || 'Deleted successfully',
      //     status: 'success',
      //     duration: 3000,
      //     isClosable: true,
      //     position: 'top-center',
      //   });

      queryClient.invalidateQueries(['customNotificationList']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to delete notification',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
